// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

import { useLocation, useParams } from "react-router-dom";

// formik components
import { ErrorMessage, Field } from "formik";

// components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelectField from "components/SoftSelectField";

function SelectField({ label, name, success, error, ...rest }) {
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const disabled = id && !containEdit;
  return (
    <SoftBox mb={1.5}>
      {label && (
        <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            {label}
          </SoftTypography>
        </SoftBox>
      )}
      <Field
        success={!containEdit && !disabled && success}
        error={!disabled && error}
        disabled={disabled}
        name={name}
        component={SoftSelectField}
        {...rest}
      />
      <SoftBox mt={0.75}>
        <SoftTypography component="div" variant="caption" color="error">
          <ErrorMessage name={name} />
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// typechecking props for SelectField
SelectField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  success: PropTypes.bool,
  error: PropTypes.bool,
};

export default SelectField;
